export const iconFontAwesomeMediaplaybackMaximize = (
	<i className="fa-solid fa-maximize"></i>
);
